<template>
  <div>
    <div class="page-header">
		<div class="add-item d-flex">
			<div class="page-title">
				<h4>{{ $t("customer_list") }}</h4>
			</div>
		</div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--			</li>-->
<!--		</ul>-->
		<div v-if="can('sales.customer', 'W')" class="page-btn">
			<!-- Trigger Button for Modal -->
			<router-link to="/customers/create" class="btn btn-added">
        <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_customer") }}
      </router-link>
		</div>
	</div>
	<!-- /product list -->
	<div class="card table-list-card">
		<div class="card-body">

			<div class="table-responsive">
				<DataTable v-if="customers.length" :tableId="'customersTable'">
					<thead>
						<tr>
							<th>{{ $t("customer_name") }}</th>
							<th>{{ $t("customer_code") }}</th>
							<th>{{ $t("due_limit") }}</th>
							<th>{{ $t("due_limit_days") }}</th>
							<th>{{ $t("customer_address") }}</th>
							<th>{{ $t("customer_bank") }}</th>
							<th>{{ $t("customer_contact_person") }}</th>
							<th>{{ $t("customer_email") }}</th>
							<th>{{ $t("customer_phone") }}</th>
							<th>{{ $t("status") }}</th>
              <th>{{ $t('action') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="customer in customers" :key="customer.id">
							<td>{{ customer.customer_name }}</td>
							<td>{{ customer.customer_code }}</td>
							<td>{{ customer.due_limit }}</td>
							<td>{{ customer.due_limit_days }}</td>
							<td>{{ customer.customer_address }}</td>
							<td>{{ customer.customer_bank }}</td>
							<td>{{ customer.customer_contact_person }}</td>
							<td>{{ customer.customer_email }}</td>
							<td>{{ customer.customer_phone }}</td>
							<td>{{ customer.status }}</td>
              <td class="action-table-data">
                <div v-if="can('sales.customer', 'E')" class="edit-delete-action">
                  <router-link :to= "{name:'CustomerEdit',params:{id:customer.id}}"
                   class="btn btn-added" >
                    <i class="ti ti-edit me-2"></i>{{ $t("edit_customer") }}
                  </router-link>
                </div>
              </td>
						</tr>
					</tbody>
				</DataTable>
        <!-- If No Data -->
        <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <h5 class="text-muted">No Data Found</h5>
          <p class="text-secondary small">Try adjusting filters or add new data.</p>
        </div>
			</div>
		</div>
	</div>
<!-- /product list -->

  </div>
</template>

<script>
import apiUrls from '@/urls';
import DataTable from '@/components/common/DataTable.vue';
import CustomerEdit from "@/views/admin_dashboard/customer/CustomerEdit";
import { hasPermission } from "@/helpers/permission";

export default {
  inject: ['globalLoading'],
  components: {
    DataTable,
    CustomerEdit
  },
  data() {
    return {
      customers: [],
    };
  },

  methods: {
    async fetchCustomers() {
      this.globalLoading(true)
      try {
        const response = await this.$axios.get(apiUrls.customers.get);
        this.customers = response.data;

      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        this.globalLoading(false)
      }
    },

    can(code, requiredLevel) {
      const perms = JSON.parse(localStorage.getItem("permissions")) || {};
      const userLevel = perms[code] || 'N';

      for (const char of requiredLevel) {
        if (!userLevel.includes(char)) {
          return false;
        }
      }
      return true;
    },
  },

  created() {
    this.fetchCustomers();
  }
};
</script>
